export const fonds = [
    {
      title: 'Save the Children',
      url:
        'https://www.savethechildren.net/what-we-do/emergencies/ukraine-crisis',
      img: new URL('../../images/fonds/save-the-children.png', import.meta.url),
    },
    {
      title: 'Project HOPE',
      url: 'https://www.projecthope.org/country/ukraine/',
      img: new URL('../../images/fonds/hope.png', import.meta.url),
  },
      {
      title: 'International Medical Corps',
      url: 'https://internationalmedicalcorps.org/country/ukraine/',
      img: new URL('../../images/fonds/medical-corps.png', import.meta.url),
  },
      {
      title: 'RAZOM',
      url: 'https://www.razomforukraine.org/',
      img: new URL('../../images/fonds/razom.png', import.meta.url),
  },
       {
      title: 'Action against hunger',
      url: 'https://www.actionagainsthunger.org/location/europe/ukraine/',
      img: new URL('../../images/fonds/hunger.png', import.meta.url),
  },
       {
      title: 'Serhiy Prytula Charity Foundation',
      url: 'https://prytulafoundation.org/en',
      img: new URL('../../images/fonds/prytula.png', import.meta.url),
    },
    {
      title: 'UNITED24',
      url: 'https://u24.gov.ua/uk',
      img: new URL('../../images/fonds/united24.png', import.meta.url),
    },
  
    {
      title: 'Medicins Sans Frontieres',
      url: 'https://www.msf.org/ukraine',
      img: new URL('../../images/fonds/sans-frontieres.png', import.meta.url),
    },
  
 
    {
      title: 'World vision',
      url: 'https://www.wvi.org/emergencies/ukraine',
      img: new URL('../../images/fonds/world-vision.png', import.meta.url),
    },
 
    
  ]